import React from "react";
import {
  Box,
  Menu,
  MenuButton,
  Flex,
  Avatar,
  Button,
  Image
} from "@chakra-ui/react";
import { useLocation, useHistory } from "react-router-dom";
import { LoginButton } from "../LoginButton";


const UserMenu = ({ firstName, lastName, userPicture }) => {
  return (
    <Menu>
      <MenuButton>
        {(firstName && lastName) ? <Avatar size="md" name={`${firstName} ${lastName}`} src={userPicture} /> : null}
      </MenuButton>
    </Menu>
  );
};

export const Header = ({ isAuthenticated, user }) => {
  const { search, pathname } = useLocation();
  const queryParams = new URLSearchParams(search);
  const appid = queryParams.get("appid");
  const userid = queryParams.get("userid");
  const previewModeParam = (queryParams.get("preview_mode") || "").toLowerCase();
  const isPreviewMode = ["1", "true", "yes"].includes(previewModeParam);
  const directModeParam = (queryParams.get("direct_mode") || queryParams.get("direct") || "").toLowerCase();
  const isDirectMode = ["1", "true", "yes"].includes(directModeParam);
  const history = useHistory();
  return (
    <Box
      as="header"
      sx={{
        position: "sticky",
        top: "0",
        background: "#fff",
        zIndex: 999,
        display: "block",
        boxShadow: "0px 15px 10px -15px rgba(0, 176, 255, 0.16)",
        border: "none"
      }}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        padding="2"
        width="100%"
      >
        <Flex
          alignItems="center"
          justifyContent="space-between"
          width="calc(100% - 68px)"
        >
          <Flex
            sx={{
              alignItems: "center",
            }}
          >
              {!isDirectMode && (
                <Image 
                  src='/images/logo.png' 
                  padding="0 10px" 
                  boxSizing="content-box" 
                  width="auto"
                  height='70px'
                  alt='logo' 
                  onClick={() =>
                    history.replace(
                      `/?appid=${appid}&userid=${userid}${isPreviewMode ? "&preview_mode=1" : ""}${isDirectMode ? "&direct_mode=1" : ""}`
                    )
                  }
                />
              )}
          </Flex>
          <Button
            variant="outline"
            colorScheme="brand"
            fontSize={{ base: "sm", sm: "sm", md: "md" }}
            onClick={() =>
              history.push(
                `/report?appid=${appid}&userid=${userid}${isPreviewMode ? "&preview_mode=1" : ""}${isDirectMode ? "&direct_mode=1" : ""}`
              )
            }
          >
            View Reports
          </Button>
        </Flex>
        <Flex flexDirection="row" alignItems="center">
          {(isAuthenticated && user) ? (
            <UserMenu
              firstName={user?.firstName}
              lastName={user?.lastName}
              userPicture={user?.userPicture}
            />
          ) : (
            <LoginButton styleProps={{ variant: "outline" }} />
          )}
        </Flex>
      </Flex>
    </Box>
  );
};
